module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    class: [_vm.$root.isRTL ? 'RLT' : ''],
    attrs: {
      "id": "app"
    },
    on: {
      "click": _vm.appClick
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-top"
    }
  }, [_c('router-view', {
    staticClass: "child-view"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c46e76f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 904
// module chunks = 2